import { IRequestRecord } from 'types/requests.interface'

export const REQ_ANNUAL = 1
export const REQ_SICK = 2
export const REQ_UNPAID = 3
export const REQ_DAYOFF = 4
export const REQ_SHIFT = 5
export const REQ_OVERTIME = 6

export const ST_PENDING = 1
export const ST_APPROVED = 2
export const ST_REJECTED = 3
export const ST_CANCELLED = 4

export const ROLE_EMPLOYEE = 1
export const ROLE_SUPERVISOR = 2
export const ROLE_MANAGER = 3
export const ROLE_HR = 4

export const requestTypeOptions = [
  { value: REQ_ANNUAL, label: 'Annual Leave' },
  { value: REQ_SICK, label: 'Sick Leave' },
  { value: REQ_UNPAID, label: 'Unpaid Leave' },
  { value: REQ_DAYOFF, label: 'Day Off' },
  { value: REQ_SHIFT, label: 'Shift Change' },
  { value: REQ_OVERTIME, label: 'Overtime' },
]

export const statusOptions = [
  { value: ST_PENDING, label: 'Pending' },
  { value: ST_APPROVED, label: 'Approved' },
  { value: ST_REJECTED, label: 'Rejected' },
  { value: ST_CANCELLED, label: 'Cancelled' },
]

export const roleOptions = [
  { value: ROLE_EMPLOYEE, label: 'Employee' },
  { value: ROLE_SUPERVISOR, label: 'Supervisor' },
  { value: ROLE_MANAGER, label: 'Manager' },
  { value: ROLE_HR, label: 'HR' },
]

export const LEAVE_TYPES = [REQ_ANNUAL, REQ_SICK, REQ_UNPAID]

export const typeLabel = (n: number) => requestTypeOptions.find((o) => o.value === n)?.label || 'Request'
export const statusLabel = (n: number) => statusOptions.find((o) => o.value === n)?.label || 'Unknown'
export const roleLabel = (n: number) => roleOptions.find((o) => o.value === n)?.label || 'Employee'

export const statusPill = (n: number): 'warning' | 'success' | 'danger' | 'neutral' => {
  if (n === ST_PENDING) return 'warning'
  if (n === ST_APPROVED) return 'success'
  if (n === ST_REJECTED) return 'danger'
  return 'neutral'
}

export const typePill = (n: number): 'info' | 'success' | 'warning' | 'neutral' => {
  if (n === REQ_SHIFT) return 'info'
  if (n === REQ_OVERTIME) return 'warning'
  if (n === REQ_DAYOFF) return 'neutral'
  return 'success'
}

export const isLeaveType = (n: number) => LEAVE_TYPES.includes(n) || n === REQ_DAYOFF

export const isApprover = (role: number) => role === ROLE_MANAGER || role === ROLE_HR

export const canCreateForOthers = (role: number) =>
  role === ROLE_SUPERVISOR || role === ROLE_MANAGER || role === ROLE_HR

export const balanceType = (reqType: number): number | null => {
  if (reqType === REQ_DAYOFF) return REQ_ANNUAL
  if (LEAVE_TYPES.includes(reqType)) return reqType
  return null
}

export const leaveDays = (from: string, to: string) => {
  const a = new Date(from)
  const b = new Date(to)
  const start = new Date(a.getFullYear(), a.getMonth(), a.getDate()).getTime()
  const end = new Date(b.getFullYear(), b.getMonth(), b.getDate()).getTime()
  const days = Math.round((end - start) / (1000 * 60 * 60 * 24)) + 1
  return days < 1 ? 1 : days
}

export const requestDays = (req: IRequestRecord) => leaveDays(req.from, req.to)

export const durationLabel = (req: IRequestRecord) => {
  if (req.type === REQ_SHIFT) return 'Swap'
  if (req.type === REQ_OVERTIME) return `+${req.overtimeHours || 0}h`
  const d = requestDays(req)
  return `${d} ${d === 1 ? 'day' : 'days'}`
}
